/*!
 * Hospitality breadcrumb trail (Menu root + hierarchy + current page).
 */
import * as React from 'react';
import { IHospitalityBreadcrumbItem } from '../../../../utils/hs-breadcrumbs';

export interface IHospitalityBreadcrumbsProps {
    items: IHospitalityBreadcrumbItem[];
    className?: string;
}

export const HospitalityBreadcrumbs: React.FC<IHospitalityBreadcrumbsProps> = ({ items, className = '' }) => {
    if (!items?.length) {
        return null;
    }

    return (
        <nav className={`hs-hospitality-breadcrumbs ${className}`.trim()} aria-label='Breadcrumb'>
            <ol className='hs-hospitality-breadcrumbs__list'>
                {items.map((item, index) => (
                    <li key={`${item.label}-${index}`} className='hs-hospitality-breadcrumbs__item'>
                        {index > 0 ? (
                            <span className='hs-hospitality-breadcrumbs__sep' aria-hidden='true'>
                                /
                            </span>
                        ) : null}
                        {item.href ? (
                            <a className='hs-hospitality-breadcrumbs__link' href={item.href}>
                                {item.label}
                            </a>
                        ) : (
                            <span className='hs-hospitality-breadcrumbs__current' aria-current='page'>
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default HospitalityBreadcrumbs;
